import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const PWA_CONFIG = {
  admin: {
    title: 'FOS Admin - Franchise Management',
    manifest: '/manifest-admin.json',
    themeColor: '#6b4423',
    appleName: 'FOS Admin'
  },
  franchise: {
    title: 'FOS Franchise - Store Operations',
    manifest: '/manifest-franchise.json',
    themeColor: '#D97706',
    appleName: 'FOS Franchise'
  },
  superadmin: {
    title: 'FOS SA - Super Admin Dashboard',
    manifest: '/manifest-superadmin.json',
    themeColor: '#1e3a5f',
    appleName: 'FOS SA'
  }
};

const usePWAConfig = () => {
  const location = useLocation();

  useEffect(() => {
    const path = location.pathname;
    let config;

    if (path.startsWith('/admin')) {
      config = PWA_CONFIG.admin;
    } else if (path.startsWith('/super-admin') || path.startsWith('/hq')) {
      config = PWA_CONFIG.superadmin;
    } else {
      config = PWA_CONFIG.franchise;
    }

    // Update document title
    document.title = config.title;

    // Update manifest link
    const manifestLink = document.getElementById('manifest-link');
    if (manifestLink) {
      manifestLink.href = config.manifest;
    }

    // Update theme color
    const themeColorMeta = document.getElementById('theme-color-meta');
    if (themeColorMeta) {
      themeColorMeta.content = config.themeColor;
    }

    // Update Apple PWA title
    const appleTitle = document.getElementById('apple-title');
    if (appleTitle) {
      appleTitle.content = config.appleName;
    }

  }, [location.pathname]);
};

export default usePWAConfig;
